import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
;;
import { Button, Columns, Column, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Control } from 'src/ui/mui-ui-kit';;
import { Form, Field } from 'react-final-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FadeInDiv, AnimatedCard } from 'src/ui/logic';
import { usePoseWithBulma } from 'src/ui/hooks';
import { UiInputAdapter } from '../../ui';
import { composeValidators, url } from '../../ui/validations';

export function LicenseEditModal({ isActive, onClickClose, data, onSubmit }) {
  const [initialData, setInitialData] = useState({});

  const { licenseNumber } = data;
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );
  useEffect(() => {
    if (isActive) {
      setInitialData(data);
    }
  }, [isActive, data]);
  return (
    <Modal isActive={isModalVisible} className="confirm-changes-modal">
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
      <ModalCard tag={AnimatedCard} pose={currentPose}>
        <ModalCardHeader>
          <ModalCardTitle
            tag="h5"
            hasTextAlign="centered"
            className="has-text-weight-semibold"
          >
            <Column tag="span" hasTextColor="primary" isPaddingless>
              {`Edit License ${licenseNumber}`}
            </Column>
          </ModalCardTitle>
        </ModalCardHeader>
        <ModalCardBody hasTextAlign="centered">
          <Form
            onSubmit={onSubmit}
            initialValues={initialData}
            render={({ handleSubmit, form, submitting }) => (
              <>
                <Columns isMultiline isCentered>
                  <Column isSize="1/2" className="is-one-third-fullhd">
                    <Field
                      component={UiInputAdapter}
                      name="licenseLink"
                      id="licenseLink"
                      validate={composeValidators('licenseLink', url)}
                      label="Link to License"
                      disabled={submitting}
                      renderIcons={() => [
                        <span
                          className="icon is-small is-right"
                          key="right-icon"
                        >
                          <FontAwesomeIcon icon={['fal', 'link']} />
                        </span>,
                      ]}
                      hasIcons="right"
                      type="url"
                    />
                  </Column>
                  <Column isSize="1/2" className="is-one-third-fullhd">
                    <Field
                      component={UiInputAdapter}
                      name="consentLink"
                      id="consentLink"
                      validate={composeValidators('consentLink', url)}
                      label="Link to Consent"
                      disabled={submitting}
                      renderIcons={() => [
                        <span
                          className="icon is-small is-right"
                          key="right-icon"
                        >
                          <FontAwesomeIcon icon={['fal', 'link']} />
                        </span>,
                      ]}
                      hasIcons="right"
                      type="url"
                    />
                  </Column>
                </Columns>

                <div className="buttons is-centered">
                  <Button
                    isOutlined
                    className="is-long"
                    hasTextColor="info"
                    onClick={onClickClose}
                  >
                    Cancel
                  </Button>
                  <Control>
                    <Button
                      isOutlined
                      className="is-long"
                      isColor="gradient-bright"
                      onClick={e => handleSubmit(e)}
                      disabled={!form.getState().dirty || submitting}
                    >
                      Submit
                    </Button>
                  </Control>
                </div>
              </>
            )}
          />
        </ModalCardBody>
      </ModalCard>
    </Modal>
  );
}

LicenseEditModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  data: propTypes.object.isRequired,
  onClickClose: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
};
